<template>
    <Modal
      :value="modalAdminPassword"
      :onClose="toggleModalAdminPassword"
      :close="false"
      :title="title"
      :size="'tiny'"
    >
      <b-row>
        <b-col md="3" lg="12" sm="3">
          <Input
            id="adminPassword"
            ref="adminPassword"
            v-model="adminPassword"
            label="Senha"
            placeholder="Digite a senha do administrador"
            labelBold
            type="password"
          />
        </b-col>
      </b-row>
      <div class="confirm-buttons">
        <Button type="error" @click="close()">Fechar</Button>
        <Button type="success" @click="send()">Confirmar</Button>
      </div>
    </Modal>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { Modal } from '@/components';
import { Button, Input } from '@/components/Form';

export default {
  name: 'ModalAdminPassword',
  components: {
    Modal,
    Button,
    Input,
  },
  props: {
    title: {
      type: String,
      default: 'Digite a senha do administrador',
    },
    parentComponentFunctionWhenSend: {
      type: Function,
      default: () => null,
    },
    parentComponentFunctionWhenClose: {
      type: Function,
      default: () => null,
    },
  },
  computed: {
    ...mapState('client', ['adminPasswordIsValid', 'modalAdminPassword']),
  },
  data() {
    return {
      adminPassword: null,
    };
  },
  methods: {
    async send() {
      await this.sendAdminPassword(this.adminPassword);
      if (this.adminPasswordIsValid) {
        this.toggleModalAdminPassword();
        await this.parentComponentFunctionWhenSend();
      }
      this.adminPassword = null;
    },
    close() {
      this.toggleModalAdminPassword();
      this.parentComponentFunctionWhenClose();
    },
    ...mapActions('client', ['sendAdminPassword', 'toggleModalAdminPassword']),
  },
};
</script>
